export const APP = "kb-drugs_reindexed_1";  // o el índice que uses
export const CRED = "elastic:vprv4*.Bvv2CvHgyd8QD";
export const URL = "https://elastic.mylogygenomics.com";
export const TYPE = "_doc";